{
  "review_contacts_table": {
    "clear_selection": "Effacer la sélection",
    "alert_message": "Examinez et gérez vos contacts entrants ici. En sélectionnant la case à côté d'un contact, vous pouvez les publier dans le CRM, les définir comme privés ou archiver leurs détails.",
    "contacts_selected": "{{count}} contacts sélectionnés",
    "contact_column": "Contact",
    "company_column": "Société",
    "location_column": "Lieu",
    "tags_column": "Tags",
    "last_interaction_column": "Dernière interaction"
  },
  "allow_marketing": {
    "success_description": "Ces contacts sont maintenant autorisés pour le marketing !"
  },
  "set_as_private": {
    "confirm_title": "Définir les contacts comme privés",
    "confirm_content": "Toutes les interactions futures (par ex. fil d'activité, qui connaît) vous incluant et ces contacts ne seront pas suivies.",
    "delete_past_interactions": "Supprimer les interactions passées entre vous et ce contact. Cette action est irréversible.",
    "remove_from_my_contacts": "Retirer de Mes contacts",
    "button": "Définir comme privé",
    "success_description": "Ces contacts ont été définis comme privés."
  },
  "merge_contacts": {
    "primary_label": "Principal",
    "merge_data_title": "Les données suivantes seront fusionnées et ajoutées sous le contact principal",
    "replace_data_title": "Les données suivantes seront remplacées par les données du contact principal :",
    "merge_items": {
      "activity_feed": "Fil d'activité",
      "who_knows": "Qui connaît",
      "notes": "Notes",
      "tasks": "Tâches",
      "phone_numbers": "Numéros de téléphone",
      "emails": "E-mails"
    },
    "replace_items": {
      "marketing_settings": "Paramètre marketing",
      "list_membership": "Adhésion à la liste",
      "company": "Société",
      "location": "Lieu",
      "job_title": "Titre du poste"
    },
    "confirmation_text": "Je comprends que la fusion de ces contacts combinera leurs données sous un seul profil. Cette action ne peut pas être annulée.",
    "merge_button": "Fusionner les contacts"
  }
}
